<template>
  <div class="page-homepre">
    <FrameHeader/>

    <!--  -->
    <div class="banner-box tac pt-5">
      
      <div class="boxed pt-4">

        <div style="height:100px;">
          <img src="/static/pic/page_home/logo-juggerworld.png" style="height: 60px;max-width: 100%;">
        </div>

        <h3>
          {{lg('',{
            en: 'Where the #BSC Community Trades NFTs',
            zh: '#BSC社区专属的NFT交易市场',
          })}}
        </h3>

        <div class="mt-3">
          <img src="/static/img/logo_jgn_on_binance.png" style="height:24px;">
        </div>

        <div class="mt-5">
          <router-link :to="{name: 'home'}" class="btn btn-primary btn-lg" style="border-radius: 50px;">
            {{lg('',{
              en: 'Explore',
              zh: '浏览探索',
            })}}
          </router-link>
        </div>
      </div>
    </div>


    <!--  -->
    <div class="boxed">

      <!-- title -->
      <div class="mt-4 border-bottom pb-2">
        <div class="d-flex">
          <span>
            {{lg('',{
              en: 'Art',
              zh: '艺术品',
            })}}
          </span>
          <router-link :to="{name: 'home'}" class="ml-auto">
            {{lg('',{
              en: 'View All',
              zh: '查看全部',
            })}}
            <i class="fas fa-chevron-right small"></i>
          </router-link>
        </div>
      </div>

      <!--  -->
      <div>
        <div class="">
          <div v-if="status_ajaxing_list" class="text-dark tac p-5">Loading...</div>

          <div v-else class="list-main-prod pb-5 w-100">
            <div class="item mb-4" v-for="(item,index) of list_main" :key="index">
              <CpCardProd 
                :data="item"
                :cfg="{
                  use_route: {name: 'home'}
                }"
              />
            </div>
          </div>
        </div>
      </div>

    </div>
    <FrameFooter/>
  </div>
</template>

<script>

export default {
  name: 'homepre',
  components: {},
  props: [],
  data() {
    return {
      list_main: [],
      status_ajaxing_list: false,
    }
  },
  computed: {},
  watch: {},
  methods: {
    async getList(){
      let v = this

      let res = await v.api('list_asset',{
        'category': 'art',
        'filter': '',
        'filter_more': {},
      },{
        vue: v,
        key_ajaxing: 'status_ajaxing_list',
      })

      if(res && res.data){
        v.list_main = res.data.splice(0,3)
      }
    },
  },
  created() {
    this.getList()
  },
  //mounted() {},
  //beforeDestroy() {},
  //update() {},
  //activited() {},
  //beforeRouteUpdate() {},
  //filters: {},
};
</script>

<style lang="scss" scoped>
  .page-homepre{
    .banner-box{
      height: 500px;
      background: url('/static/pic/page_home/banner.jpg') center bottom no-repeat;
      background-size: cover;

      @media(max-width: 788px){
        height: 450px;
        background-position: 40% center;
      }
    }
  }
</style>